export default "__VITE_ASSET__by6Bxmgl__"